/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccountingResponse } from '../models/AccountingResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AccountingService {
    /**
     * @returns AccountingResponse OK
     * @throws ApiError
     */
    public static createAccountingStatement({
        from,
        to,
    }: {
        from: string,
        to: string,
    }): CancelablePromise<AccountingResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/accounting/statistic',
            query: {
                'from': from,
                'to': to,
            },
        });
    }
}
